export const calculateProductsForPage = (
  paginaAtual: number,
  totalProdutosPorPagina: number,
  totalProdutos: number
): string => {
  const indiceInicial = (paginaAtual - 1) * totalProdutosPorPagina + 1
  const indiceFinal = Math.min(
    paginaAtual * totalProdutosPorPagina,
    totalProdutos
  )

  const textoExibicao = `${indiceInicial}-${indiceFinal} de mais de ${totalProdutos} resultados encontrados`

  return textoExibicao
}
